// Design tokens straight from the mockup (Claude Design · abekus · Payment
// System.html) — kept local to this component rather than promoted to the
// app theme, since they're specific to this card's look.
export const GREEN = '#137a44';
export const GREEN_DARK = '#3fcc82';
export const MUT = '#64788c';
export const MUT_DARK = '#93a4b6';
export const MUT2 = '#8b9bab';
export const LINE = '#e4e9ef';
